import React, { useState, useEffect } from "react";
import {
  List,
  ListItem,
  Divider,
  ListItemText,
  ListItemAvatar,
  Typography,
} from "@material-ui/core";
import { Notifications as NotificationsIcon } from "@material-ui/icons/";
import { connect } from "react-redux";
import Box from "@material-ui/core/Box";
import Loading from "../Loading";
import { newNotification, getNotifications } from "../../actions/authActions";
import InfiniteScroll from "react-infinite-scroller";

const Notifications = (props) => {
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [allLoaded, setAllLoaded] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  useEffect(() => {
    if (notifications.length === 0) {
      props.getNotifications(props.auth.seller._id, 0);
    }
    if (props.auth.newNotification) {
      props.getNotifications(props.auth.seller._id, 0);
      props.newNotification(false);
    }
    if (props.auth.notifications.length !== 0) {
      setNotifications(props.auth.notifications);
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    if (loadingMore && props.auth.msg === "No More Notifications") {
      setLoading(false);
      setAllLoaded(true);
      setLoadingMore(false);
    }
  }, [props.auth.msg, loadingMore]);

  useEffect(() => {
    setNotifications(props.auth.notifications);
    setLoading(false);
    setLoadingMore(false);
  }, [props.auth.notifications]);

  const loadMoreItems = (lengthOfItems) => {
    setLoadingMore(true);
    props.getNotifications(props.auth.seller._id, lengthOfItems);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <List>
        <h3
          style={{
            color: "white",
            backgroundColor: "black",
            borderRadius: "20px",
            padding: "10px 0 10px 40px",
            fontWeight: 100,
            fontSize:22
          }}
        >
          Notifications
        </h3>
        {notifications.length === 0 ? (
          <div style={{ heigth: "400px" }}>
            <div
              style={{
                textAlign: "center",
                color: "deepSkyBlue",
                display: "block",
                marginTop: "150px",
              }}
            >
              <NotificationsIcon style={{ fontSize: "100px" }} />
              <h2>No Notifications Yet</h2>
            </div>
          </div>
        ) : (
          <InfiniteScroll
            pageStart={0}
            loadMore={() => {
              if (!loadingMore) {
                loadMoreItems(notifications.length);
              }
            }}
            hasMore={!allLoaded}
            threshold={10}
          >
            {notifications.map((response, index) => {
              const { title, description, date } = response.notification;
              const readable_date = new Date(date).toLocaleDateString();
              const readable_time = new Date(date).toLocaleTimeString();

              return (
                <div
                  style={{
                    borderRadius: 20,
                    boxShadow: "1px 1px 6px 0px rgba(0,0,0,0.9)",
                    marginBottom: 15,
                  }}
                >
                  <ListItem alignItems="flex-start" style={{padding: '10px 20px 0 0'}}>
                    <ListItemAvatar>
                      {/* <Avatar alt="avatar" src={} /> */}
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Typography>
                          <Box fontWeight="fontWeightBold">{title}</Box>
                        </Typography>
                      }
                      secondary={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <Typography
                            component="span"
                            variant="body1"
                            color="textPrimary"
                          >
                            {description}
                          </Typography>
                          <p>{`${readable_time} - ${readable_date}`}</p>
                        </div>
                      }
                    />
                  </ListItem>
                </div>
              );
            })}
          </InfiniteScroll>
        )}
      </List>
      {loadingMore && (
        <div>
          <h3
            style={{ color: "green", textAlign: "center", paddingBottom: 30 }}
          >
            Loading More...
          </h3>
        </div>
      )}
      {allLoaded && (
        <div
          style={{
            margin: "30px auto",
            alignSelf: "center",
            backgroundColor: "gray",
            borderRadius: 50,
            width: 10,
            height: 10,
          }}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { newNotification, getNotifications })(
  Notifications
);
